export const FRAUD_PROTECTION_COUNTRIES = 'countryIds';
export const FRAUD_PROTECTION_DEVICE_TYPE = 'deviceType';
export const FRAUD_PROTECTION_OS_VERSION = 'osVersion';
export const FRAUD_PROTECTION_OS_VERSION_OPERATOR = 'operator';
export const FRAUD_PROTECTION_OS_VERSION_VALUE = 'value';
export const FRAUD_PROTECTION_OS_VERSION_MAX_VALUE = 'maxValue';
